import { MDBModalRef } from 'ng-uikit-pro-standard';
import { Component, OnInit } from '@angular/core';
import { NavegadorCheckService } from 'src/app/core/navegador-check.service';

@Component({
  selector: 'app-modal-bloqueador',
  templateUrl: './modal-bloqueador.component.html',
  styleUrls: ['./modal-bloqueador.component.scss']
})
export class ModalBloqueadorComponent implements OnInit {
  abrirModal = false;
  visivel: 'info' | 'mais' = 'info';

  constructor(
    public modalRef: MDBModalRef,
    private navegadoresService: NavegadorCheckService,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.modalRef.hide();
  }
}
